export const paths = {
  index: '/',
  auth: {
    jwt: {
      login: '/auth/jwt/login',
      forgotPassword: '/auth/jwt/forgot-password',
      renewPassword: '/auth/jwt/renew-my-password',
      newNaber: '/auth/jwt/new-naber',
    },
  },
  oauth: {
    mcpConsent: '/oauth/mcp/consent',
  },
  /** Ouverte par la console : `#code=…&next=…` (TEC-1911). */
  impersonate: '/impersonate',
  dashboard: {
    index: '/',
    account: '/settings/account/profile',
    /** Ancienne page à onglets (profil / paramètres / sécurité), hors layout Paramètres. */
    legacyAccountSettings: '/account',
    settings: {
      index: '/settings',
      account: {
        profile: '/settings/account/profile',
        /** Onglet Préférences du profil (`?tab=` lu par la page Profil). */
        profilePreferences: '/settings/account/profile?tab=preferences',
        notifications: '/settings/account/notifications',
        security: '/settings/account/security',
      },
      org: {
        general: '/settings/org/general',
        agencies: '/settings/org/agencies',
        agency: (groupId: string) =>
          `/settings/org/agencies/${encodeURIComponent(groupId)}`,
        formulaire: '/settings/org/formulaire',
        members: '/settings/org/members',
        member: (userId: string) =>
          `/settings/org/members/${encodeURIComponent(userId)}`,
        roles: '/settings/org/roles',
        // Un rôle s'ouvre dans l'onglet « Configurer » de la page Rôles et permissions (24/09/2026).
        role: (roleId: string) =>
          `/settings/org/roles?tab=configure&role=${encodeURIComponent(
            roleId
          )}`,
        emailTemplates: '/settings/org/email-templates',
        subscription: '/settings/org/subscription',
        /** Facturation (Hyperline) — ticket séparé. Visible si enrolled. */
        billing: '/settings/org/billing',
      },
      modules: {
        nabuAssistant: '/settings/modules/nabu-assistant',
      },
      support: {
        help: '/settings/support/help',
      },
    },
    managementConsole: {
      index: '/management-console',
      establishment: '/management-console/establishment',
    },
    customerFlow: {
      index: '/customer-flow',
      customer: '/customer-flow/customer',
      customerDetail: '/customer-flow/customer/',
      flow: '/customer-flow/flow',
      flowDetail: '/customer-flow/flow/',
      referentials: '/customer-flow/referentials',
      referentialDetail: (id: string) =>
        `/customer-flow/referentials/${encodeURIComponent(id)}`,
    },
    documents: {
      index: '/documents',
      list: '/documents/list',
      manage: '/documents/list',
      exported: '/documents/exported',
      deleted: '/documents/deleted',
      batchImport: (id: string) =>
        `/documents/${encodeURIComponent(id)}`,
      /** Produit agentique : la déclaration stockée du dossier. */
      declaration: (id: string, declarationId?: string) =>
        `/documents/${encodeURIComponent(id)}/declaration${
          declarationId ? `?declaration=${encodeURIComponent(declarationId)}` : ''
        }`,
      /** Le document source de la déclaration, seul dans un onglet (second écran). */
      declarationSource: (id: string, declarationId: string) =>
        `/documents/${encodeURIComponent(
          id
        )}/declaration/source?declaration=${encodeURIComponent(declarationId)}`,
      /** Tarifill seul dans un onglet (second écran), relié à la déclaration. */
      declarationTarifill: (id: string, declarationId: string) =>
        `/documents/${encodeURIComponent(
          id
        )}/declaration/tarifill?declaration=${encodeURIComponent(
          declarationId
        )}`,
    },
  },
  backoffice: {
    index: '/backoffice',
    users: {
      index: '/backoffice?tab=users',
      edit: (userId: string) => `/backoffice/users/${userId}/edit`,
    },
    organizations: {
      index: '/backoffice?tab=organizations',
      edit: (organizationId: string) =>
        `/backoffice/organizations/${organizationId}/edit`,
      groupEdit: (organizationId: string, groupId: string) =>
        `/backoffice/organizations/${organizationId}/groups/${groupId}/edit`,
    },
    connectors: {
      index: '/backoffice?tab=connectors',
    },
  },
  401: '/401',
  404: '/404',
  500: '/500',
} as const
